import './filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters.GoogleMyBusinessFilters'

class Monitoring.Views.SocialContents.Filters.Ratings extends Monitoring.Views.SocialContents.Filters.FilterView
  template: JST['backbone/templates/monitoring/filters/ratings']

  events:
    'click .apply': 'apply'
    'click #all-input': '_selectAll'
    'click .rating': '_selectRating'
    'click .review-stars': '_selectRatingFromStars'

  initialize: ({searchQuery}) ->
    @searchQuery = searchQuery
    @stars = @_createReviewStars()

  render: ->
    @$el.html(@template)
    @stars.forEach((star, index) =>
      @$el.find(".stars#{index + 1}").append(star.render().el)
      star.setRating(index + 1)
    )
    @

  destroy: ->
    @stars.forEach((star) -> star.remove())
    @remove()

  _toggleSelectAllInputs: ({isChecked}) ->
    for rating in _.range(1, 6)
      @$el.find("#stars#{rating}-input").prop('checked', isChecked)

  _selectAll: ->
    isChecked = @$el.find('#all-input').is(':checked')
    @_toggleSelectAllInputs({isChecked: isChecked})

  _selectRating: (event) ->
    isChecked = @$el.find("##{event.target.id}").is(':checked')
    @_uncheckSelectAll() unless isChecked

  _uncheckSelectAll: ->
    @$el.find('#all-input').prop('checked', false)

  _selectRatingFromStars: (event) ->
    checkbox = @$el.find(event.target).closest('.review-stars').parent().siblings('.rating')
    isInitiallyChecked = checkbox.is(':checked')
    checkbox.prop('checked', !isInitiallyChecked)
    @_uncheckSelectAll() if isInitiallyChecked

  _createReviewStars: ->
    stars = []
    for rating in _.range(1, 6)
      stars.push(new Monitoring.Views.ReviewStarsView())
    stars

  _getRatings: ->
    ratings = []
    for rating in _.range(1, 6)
      isChecked = @$el.find("#stars#{rating}-input").is(':checked')
      ratings.push(rating) if isChecked
    ratings

  apply: ->
    @searchQuery.setStarRatings(@_getRatings())
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
